export default "__VITE_ASSET__BG9zJJz4__"